var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v("Agendamentos a realizar")]),_c('table-agendamentos-futuros',{attrs:{"horariosAgendados":_vm.horariosAgendados,"loading":_vm.loading || !_vm.allowsRender}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }